<youtube-player
  [videoId]="videoId"
  [playerVars]="{ autoplay: 0, rel: 0, loop: 1, origin, showInfo: 0, playlist: videoId }"
  (stateChange)="onStateChange.emit($event)"
></youtube-player>
